<template>
  <v-container id="report-list">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>Relatórios Administrativos</v-col>
      <v-col class="text-right">
        <v-btn
          v-if="
            isFullAdmin ||
            (groupsConfig.novoRelatorioAdministrativo &&
              config.novoRelatorioAdministrativo)
          "
          outlined
          color="primary"
          class="ml-3"
          :to="
            '/cidade/' +
            payload.municipioId +
            '/relatorio-administrativo/inserir'
          "
        >
          Novo Relatório Administrativo
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.relatorios"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada:
                  props.item.statusRelatorioId === 2 ||
                  props.item.statusRelatorioId === 4,
                evidenciar: props.item.statusRelatorioId === 3,
                rejeitada:
                  props.item.statusRelatorioId === 1 ||
                  props.item.statusRelatorioId === 0,
              }"
            >
              <td>
                <a
                  :href="
                    './#/cidade/' +
                    props.item.municipioId +
                    '/relatorio-administrativo/obter/' +
                    props.item.relatorioAdministrativoId
                  "
                  >{{ props.item.titulo }}</a
                >
              </td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>
                {{ props.item.criacao | moment("DD/MM/YYYY") }}
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum relatório administrativo retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AppCityHeader } from "@/modules/city";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "titulo" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Criado em", value: "criacao" },
      ],
      payload: {
        municipioId: this.$route.params.id,
        relatorios: [],
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getReports() {
      this.setLoading(true);
      administrativeReportAPI
        .getByCity(this.payload.municipioId)
        .then((resp) => {
          this.payload.relatorios = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
  mounted() {
    this.getReports();
  },
};
</script>
